import React from 'react';
import WordListsContainer from '../components/wordlists.container';

/** The word list library: what gets censored, and which project reaches for which list. */
const WordListsPage: React.FC = () => <WordListsContainer />;

export default WordListsPage;
